<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row class="m-3">
                <b-col cols="12">
                    <div>
                        <p class="font-weight-bold">B. PROGRAM INFORMATION</p>
                    </div>
                    <div>
                        <p>The following information is pulled from the application form you submitted.</p>
                    </div>
                    <b-table-simple responsive striped hover class="text-sm text-md-md">
                        <b-tbody>
                            <b-tr v-for="(item, j) in data" :key="j" class="py-2 py-md-3">
                                <b-td class="font-weight-bold" style="width: 40%;">{{ item.key }}</b-td>
                                <b-td>
                                    <span v-if="item.isHtml" v-html="item.value"></span>
                                    <span v-else-if="item.value2 != null">{{ item.value }} / {{ item.value2 }}</span>
                                    <span v-else>{{ item.value }}</span>
                                </b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                </b-col>
                <b-col cols="12" class="mt-3">
                    <b-row class="d-flex align-items-center flex-column flex-md-row justify-content-md-between">
                        <b-col cols="12" md="8" class="mb-2 mb-md-0 d-flex flex-row-md-reverse flex-row">
                            <ValidationProvider name="status" rules="required" v-slot="{ errors }">
                                <div class="d-flex flex-row-reverse">
                                    <b-form-checkbox
                                        id="checkbox-exchange-b"
                                        v-model="form.status"
                                        name="checkbox-exchange-b"
                                        value="accepted"
                                        :unchecked-value="null"
                                        class="text-sm text-md-md ml-4"
                                    />
                                    <div>
                                        I read and confirm that I understand the information in Section B.
                                    </div>
                                </div>
                                <b-form-invalid-feedback v-if="errors[0]">
                                    {{ errors[0] }}
                                </b-form-invalid-feedback>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="12" md="4" class="text-md-right mt-3">
                            <b-button type="submit" @click="next" variant="primary" class="w-100 w-md-auto">
                                {{ $t('next') }}
                            </b-button>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </ValidationObserver>
    </div>
</template>
<script>
import {mapGetters} from "vuex";
import EnrollmentAgreementForm from "@/services/EnrollmentAgreementForm";

export default {
    data() {
        return {
            form: {},
            data: []
        }
    },
    created() {
        this.getData()
    },
    computed: {
        ...mapGetters({
            formData: "enrollmentAgreementForm/formData"
        })
    },
    methods: {
        async getData() {
            window.scrollTo(0, 0)
            const formData = this.formData
            let user = await JSON.parse(localStorage.getItem('user'));
            let studentPrograms = user?.student?.student_program || [];
            let activeProgs = studentPrograms.filter(p => ['100', '101'].includes(p.student_status));

            let isMultiple = activeProgs.length > 1;
            let programOfStudyVal = isMultiple
                ? activeProgs.map(p => p.program_name).filter(Boolean).join(', ')
                : formData.program_name;

            let totalCreditsVal;
            let totalCreditsVal2 = null;

            if (isMultiple) {
                let activeProgsDetailed = activeProgs;
                try {
                    const responses = await Promise.all(
                        activeProgs.map(p => EnrollmentAgreementForm.getStudentInformation(p.id))
                    );
                    activeProgsDetailed = responses.map(res => res.data.data);
                } catch (e) {
                    console.error('Error fetching active program details:', e);
                }
                totalCreditsVal = activeProgsDetailed.map((p, i) => {
                    const cred = p.total_credit_required_for_graduation;
                    const comma = i < activeProgsDetailed.length - 1 ? ',' : '';
                    return `${cred} credits for ${p.program_name}${comma}`;
                }).join('<br>');
            } else {
                totalCreditsVal = formData.total_credit_required_for_graduation ? formData.total_credit_required_for_graduation : null;
                totalCreditsVal2 = formData.credit ? formData.credit : null;
            }

            this.data = [
                {
                    key: 'Program of Study',
                    value: programOfStudyVal,
                },
                {
                    key: 'Program Start Date',
                    value: formData.registration_date,
                },
                {
                    key: 'Registration Type',
                    value: formData.registration_type_text,
                },
                {
                    key: 'Enrollment Status',
                    value: formData.student_status_text,
                },
                {
                    key: 'Total Credits Required for Graduation: (for students who do not transfer any credit from another institution)',
                    value: totalCreditsVal,
                    value2: totalCreditsVal2,
                    isHtml: isMultiple,
                }
            ];
        },
        async next() {
            const isValid = await this.$refs.formModalValidate.validate();
            if (isValid) {
                this.$emit('next', 1)
            }
        },
        back() {
            this.$emit('back', -1);
        }
    }
}
</script>
